import { Env } from '../../env';

const api = {
  create: () => `${Env.Endpoint}/session`,
  get: (sessionId: string) => `${Env.Endpoint}/${sessionId}/session`,
  updateContext: (sessionId: string) =>
    `${Env.Endpoint}/${sessionId}/session/context`,
  updateDisplay: (sessionId: string) =>
    `${Env.Endpoint}/${sessionId}/session/display`,
  updateSorting: (sessionId: string) =>
    `${Env.Endpoint}/${sessionId}/session/sortOrder/rooms`,
  delete: (sessionId: string) => `${Env.Endpoint}/${sessionId}/session`,
};

export const SessionApi = api;
